
<div class="home-page-wrapper">
  <!-- [selectedTabIndex]="index"  -->
  <div class="filter-details">
    <div class='align-filter' >
      <div style="flex: 1;">
        <gtw-home-page-filter [tabList]="taxTypesList" [index]="taxTypeIndex"  (selectedTab)= "filterData()" style="display: block;"></gtw-home-page-filter>
        <gtw-home-page-filter class="tab-set-2"   [index]="catIndex"  [tabList]="categoryList" (selectedTab)= "filterData()" style="display: block;"></gtw-home-page-filter>
      </div>
      <div class="gtw-web-components a-search-wrapper col-12 no-gutters" style="margin-left: 18px; padding: 5px 0px; width: 100%; flex: 1;">
        <div>
          <ap-search
            [placeholder]="searchPlaceholder"
            [searchType]="'secondary'"
            [disabled]="searchDisabled"
            [filtered]="false"
            [isRecentSearch]="false"
            [styleClass]="'home-page-search'"
            [(ngModel)]="tagName"
            [list]="homeSearchList"
            [noResultMsg]="searchNoResultMsg"
            [noHistoryMsg]="searchNoHistoryMsg"
            (onSearch)="testSearch($event)"
            (onClear)="clearSearch()">
          </ap-search>
        </div>
      </div>
    </div>
    <app-loader [loaded]="isLoaded">
      <div class="change-view-icns">
        <div>
          Results
        </div>
        <!-- (click)="orderByKey({field:'SCREEN_NAME'})" -->
        <ul class="gtw-web-components sort-links">
          <li (click)="isCard=!isCard">
            <span class="Appkit4-icon"
            [ngClass]="{'icon-grid-view-outline' : !isCard, 'icon-table-data-outline': isCard}"></span>
          </li>
          <li class="sort-icon-item" (gtwClickOutside)="hideHomeSortMenu($event)">
            <span class="Appkit4-icon icon-filter-outline sort-trigger"
              role="button" tabindex="0"
              [attr.aria-label]="'Sort screens'"
              (click)="toggleHomeSortMenu()"
            (keydown.enter)="toggleHomeSortMenu()"></span>
            @if (isHomeSortMenuOpen) {
              <div class="sort-list-panel">
                <ap-list [bordered]="false" [split]="false" [styleClass]="'home-sort-list'" [role]="'listbox'">
                  @for (item of homePageSortItems; track item) {
                    <ap-list-item
                      [class.selected]="!!item.selected"
                      [attr.role]="'option'"
                      [attr.aria-selected]="!!item.selected"
                      [attr.aria-label]="setSortAriaLabel(item)"
                      (click)="selectHomePageSort(item)"
                      (keyup.enter)="selectHomePageSort(item)">
                      {{ item.label || item.text }}
                    </ap-list-item>
                  }
                </ap-list>
              </div>
            }
          </li>
          <li><span class="Appkit4-icon icon-refresh-outline"></span></li>
        </ul>
      </div>

      <div>
        @if ((filteredScreens | datafilter : {SCREEN_NAME:tagName, TAG_NAME:tagName, SCREEN_DESC:tagName,BRDCUMB:tagName} ); as newFilteredScreens) {
          @if (newFilteredScreens.length > 0) {
            <div>
              <div>
                @if (!isCard) {
                  <div class="viewport">
                    @for (screen of newFilteredScreens; track screen; let i = $index) {
                      <div>
                        <gtw-screen-details class="screen-details" [(screen-details)]="newFilteredScreens[i]" [base-url-admin]="baseURLs.admin"
                          [client-key]="clientKey" [is-card]="isCard" (load-screen)="loadClickedScreen(screen)"
                          [base-url]="baseURLs.api" [scenario]="scenario" [tax_year]="tax_year">
                        </gtw-screen-details>
                      </div>
                    }
                  </div>
                }
                @if (isCard) {
                  <div class="viewport">
                    @for (screen of newFilteredScreens; track screen; let i = $index) {
                      <div>
                        @if (i % 3 == 0) {
                          <div class="card-view">
                            <gtw-screen-details class="screen-details" [(screen-details)]="newFilteredScreens[i]" [base-url-admin]="baseURLs.admin"
                              [client-key]="clientKey" [is-card]="isCard" (load-screen)="loadClickedScreen(screen)"
                              [base-url]="baseURLs.api" [scenario]="scenario" [tax_year]="tax_year">
                            </gtw-screen-details>
                            @if (i + 1 < newFilteredScreens.length) {
                              <gtw-screen-details class="screen-details"
                                [(screen-details)]="newFilteredScreens[i+1]" [base-url-admin]="baseURLs.admin"
                                [client-key]="clientKey" [is-card]="isCard" (load-screen)="loadClickedScreen(screen)"
                                [base-url]="baseURLs.api" [scenario]="scenario" [tax_year]="tax_year">
                              </gtw-screen-details>
                            }
                            @if (i + 2 < newFilteredScreens.length) {
                              <gtw-screen-details class="screen-details"
                                [(screen-details)]="newFilteredScreens[i+2]" [base-url-admin]="baseURLs.admin"
                                [client-key]="clientKey" [is-card]="isCard" (load-screen)="loadClickedScreen(screen)"
                                [base-url]="baseURLs.api" [scenario]="scenario" [tax_year]="tax_year">
                              </gtw-screen-details>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (newFilteredScreens.length==0) {
            <div class="no-records-msg">
              No Records Found...
            </div>
          }
        }
        @if (filteredScreens.length==0) {
          <div class="no-records-msg">
            No Records Found...
          </div>
        }
      </div>

    </app-loader>
  </div>


  <div class="screen-updates">
    <div>
      <gtw-home-page-screens-updates
        [base-url] = "baseURLs.api"
        [all-screens] ="allScreens"
        [active-screen-keys] = "activeScreenKeys"
        (load-screen)="loadClickedScreen($event)"
        [client-key]="clientKey">
      </gtw-home-page-screens-updates>
    </div>
  </div>

</div>
